<template>
    <v-container>
        <h1>By Elections</h1>
        <br/>
        <loader v-if="loading" />        
        <v-data-table 
                    v-if="!loading"
                    :headers="HEADERS"
                    :footer-props="FOOTERS"
                    :items="items"
                    :rows-per-page-items="ROWS_LISTITEMS"
                    :pagination.sync="PAGINATION"
                    :disable-initial-sort="true"
                    class="elevation-1">

            <template v-slot:items="props">
                <router-link class="tr" :to="{ name: 'ByElectionResults', params: { year: props.item.Year, electionId: props.item.Id, division: props.item.Division }}">
                    <td class="text-xs-left">{{ props.item.Year }} {{ props.item.Division }}</td>
                </router-link>
            </template>
        </v-data-table>        
    </v-container>
</template>

<script>    
    import Loader from '@/components/Loader.vue';
    import axios from 'axios';
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri;

    export default {
        created() {
            this.initialiseItems();
        },
        components: {
            Loader
        },
        data() {
            return {
                items: [],
                loading: true,

                ROWS_LISTITEMS: [5, 10, 50, {
                    "text": "$vuetify.dataIterator.rowsPerPageAll",
                    "value": -1
                }],

                PAGINATION: {
                    rowsPerPage: this.$store.state.ROWS_PER_PAGE
                },

                HEADERS: [{
                    text: 'Year',
                    value: 'Year',
                    align: 'left',
                    sortable: true,
                }],

                FOOTERS: {
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus',
                },
            }
        },

        methods: {
            initialiseItems() {
                this.loading = true;
                const url = 'Elections/ByElections';
                axios.get(`api/${url}`)
                    .then(response => {
                        this.items = response.data;
                        this.loading = false;
                    });
            }
        },
    }
</script>

<style lang="stylus" scoped>
    .v-progress-circular {
        margin: 1rem
    }

    a {
        color: #fff;
        text-decoration: underline;
    }
</style>
